<script setup lang="ts">
import { company } from '@/data/company';

// Свойства и их значения для блока сведений о лизинговой организации
const orgDetails = [
  { label: 'Полное наименование', value: company.nameFull },
  { label: 'Сокращённое наименование', value: company.nameShort },
  {
    label: 'Наименование на белорусском языке',
    value: `${company.nameFullBe} (${company.nameShortBe})`,
  },
  { label: 'Учётный номер плательщика (УНП)', value: company.unp },
  {
    label: 'Регистрационный номер в ЕГР',
    value: `${company.egrNumber}, дата государственной регистрации — ${company.egrDate}`,
  },
  {
    label: 'Реестр лизинговых организаций',
    value: `Регистрационный номер ${company.registryNumber}, дата включения — ${company.registryDate}`,
  },
];
</script>

<template>
  <!-- Сведения о лизинговой организации -->
  <section class="section-tinted">
    <div class="container-narrow stack-gap">
      <div v-for="item in orgDetails" :key="item.label" class="grid grid-gap-sm">
        <p class="field-hint">{{ item.label }}</p>
        <p>{{ item.value }}</p>
      </div>
    </div>
  </section>

  <!-- Уставный фонд -->
  <section>
    <div class="container-narrow grid grid-gap-sm">
      <h2 class="field-hint">Уставный фонд</h2>
      <p>{{ company.charterFund }}</p>
    </div>
  </section>
</template>
